import React from "react"
import {startCase} from "lodash"
import {DocumentTypeHeaderProps} from "./types"

const DocumentTypeHeader = ({documentType}: DocumentTypeHeaderProps) => {
	return <div className="first-column">{startCase(documentType)}</div>
}

export default DocumentTypeHeader
